import styled from 'styled-components'

import { textStyles } from '../../theme'

export const Skip = styled.a`
  position: absolute;
  left: -999px; /* Hides it off-screen */
  top: auto;
  width: 1px;
  height: 1px;
  overflow: hidden;

  &:focus {
    left: 10px;
    top: 10px;
    width: auto;
    height: auto;
    padding: 8px 16px;
    background: ${({ theme }) => theme.colors.greenAccent};
    color: #fff;
    z-index: 1000;
    text-decoration: none;
    border-radius: 4px;
  }
`

export const Text = styled.p`
  ${textStyles.firaSansTextBase}
`
